export const environment = {
    production: true,
    firebase: {
        apiKey: "AIzaSyDkisBittUBkYRk_b-X4jFiRUTgnix04pU",
        authDomain: "trustedhealthdata.firebaseapp.com",
        projectId: "trustedhealthdata",
        storageBucket: "trustedhealthdata.appspot.com",
        messagingSenderId: "878303105819",
        appId: "1:878303105819:web:0a2d44fd5c25fafe0f39be"
    } 
};
